import { COLOR_PALETTE } from 'constants/ui';

export const getMessageToolsContainerStyles = (justifyContent, sx) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  justifyContent,
  ...sx,
});

export const copyButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
  cursor: 'pointer',
  color: COLOR_PALETTE.BLUE[6],
  background: 'none',
  border: 'none',
  padding: 0,
};
